/******************************************************************************************
 *	User Roles
 *******************************************************************************************
 *
 * User roles are key-value pairs where the value is a power of 2.
 * Each application state has an access property.
 * This is a bitmask determined by one or more user roles allowed to access it with bitwise OR operations between each.
 * Authorizing a user on a state is a bitwise AND operation between state access property and user role with the result converted to boolean. (Auth service)
 *
 * Example:
 * access: RESELLER_TEAM_ADMIN  | LICENSE_ADMIN_READ_ONLY | LICENSE_ADMIN_READ_WRITE = 4 | 8 | 16 = 28
 * Checking if user role can access a route with the above access property:
 * !!(RESELLER_TEAM_ADMIN & access) = !!(4 & 28) = !!(4) = true
 * !!(RESELLER_TEAM_MEMBER & access) = !!(2 & 28) = !!(0) = false
 *
 */
(function() {
  

  angular
    .module('rcServices.rcUserRoles', [])
    .constant('RC_USER_ROLES', {
      ANONYMOUS: 1, //000001,
      RESELLER_TEAM_MEMBER: 2, //000010,
      RESELLER_TEAM_ADMIN: 4, //000100,
      LICENSE_ADMIN_READ_ONLY: 8, //001000,
      LICENSE_ADMIN_READ_WRITE: 16, //010000
      LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER: 32 //100000
    })
    .provider(
      'RcUserRoles',
      /* @ngInject */
      function(RC_USER_ROLES) {
        //Returns access level for passed in user roles
        this.getAccessLevel = function() {
          if (!arguments.length) {
            return 0;
          }

          return Array.prototype.reduce.call(arguments, function(previousValue, currentValue) {
            return previousValue | currentValue;
          });
        };

        //Helper/shortcut for "allow access to all"
        var WILDCARD_ACCESS_LEVEL;
        this.getWildcardAccessLevel = function() {
          if (!WILDCARD_ACCESS_LEVEL) {
            var arRoleLevels = [];
            for (var role in RC_USER_ROLES) {
              arRoleLevels.push(RC_USER_ROLES[role]);
            }
            WILDCARD_ACCESS_LEVEL = this.getAccessLevel.apply(this, arRoleLevels);
          }

          return WILDCARD_ACCESS_LEVEL;
        };

        //Provided service
        this.$get = [
          function() {
            //Public API of service
            var exports = {};

            /*=== Login role priority ===*/
            //rolePriority is an array of role names (e.g. RESELLER_TEAM_ADMIN) sorted by access level from high to low.
            //This is used to decide which role a user has after the JIL authorization call returns.
            //Thus, the app attepts to match the highest credential a logged in user can have.
            var rolePriority;
            exports.getRolePriority = function() {
              if (!rolePriority) {
                rolePriority = [];
                for (var role in RC_USER_ROLES) {
                  if (RC_USER_ROLES.hasOwnProperty(role)) {
                    var highestRole = rolePriority[0];

                    if (!highestRole || RC_USER_ROLES[highestRole] <= RC_USER_ROLES[role]) {
                      rolePriority.unshift(role);
                    } else {
                      //Otherwise, insert after first item
                      rolePriority.splice(1, 0, role);
                    }
                  }
                }
              }
              return rolePriority;
            };

            /*=== Get least powerful role name ===*/
            exports.getLowestUserRole = function() {
              var minRoleLevel;
              var minRoleName;
              for (var role in RC_USER_ROLES) {
                if (!minRoleName || RC_USER_ROLES[role] < minRoleLevel) {
                  minRoleLevel = RC_USER_ROLES[role];
                  minRoleName = role;
                }
              }
              return minRoleName;
            };

            /*=== Get default state name for a given role ===*/
            //Default state name for each user role
            var defaultUserRoleStateNames = {
              ANONYMOUS: 'login',
              RESELLER_TEAM_MEMBER: 'customers.defaultSegment',
              RESELLER_TEAM_ADMIN: 'dashboard',
              LICENSE_ADMIN_READ_ONLY: 'licenseAdmin.search',
              LICENSE_ADMIN_READ_WRITE: 'licenseAdmin.search',
              LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER: 'licenseAdmin.search'
            };

            //Return default state name for passed in numeric role (e.g. 1 for ANONYMOUS and 16 for LICENSE_ADMIN_READ_WRITE)
            exports.getStateNameByRole = function(role) {
              if (!role || !RC_USER_ROLES.hasOwnProperty(role)) {
                return defaultUserRoleStateNames.ANONYMOUS;
              }

              return defaultUserRoleStateNames[role];
            };

            //Expose public methods
            return exports;
          }
        ];
      }
    );
})();
